import { type RolesEnum } from "graphql/__generated__/graphql";
import { useMe } from "hooks";
import { intersection } from "lodash-es";

export const hasOneOfRoles = (roles: RolesEnum[]) => {
  const { me } = useMe();

  return intersection(roles, me?.roles ?? []).length > 0;
};
